import classes from './MainLayout.module.css'
const MainLayout = props =>
    (
        <div className={classes.Layout}>
            <main>
                {props.children}
            </main>
        </div>
    );
export default MainLayout;